import React, { useEffect} from "react";
import * as LocalStorage from "../../utils/localStorage";
import { useDispatch, useSelector } from "react-redux";
import Header from "../header";
import { setDashboardData} from "../redux/actions/dashboardActions";
import { setproductsData } from "../redux/actions/productsActions";
import { setAccountsData } from "../redux/actions/AccountPageActions";
import LatestHits from "./LatestHits";
import Performance from "./performanceSection";
import StorageSection from "./StorageSection";
import Notifications from "./notificationSection";
import OrdersSection from "./ordersSection";
import styles from "./dashBoardStyles.module.css";

const DashBoard = () => {
  const {data:dashBoardData} = useSelector(
    (state) => state.dashboard
  );
  const dispatch = useDispatch();
  useEffect(() => {
    if (
      !dashBoardData
    ) {
      fetch("https://reactmusicplayer-ab9e4.firebaseio.com/project-data.json")
        .then((res) => res.json())
        .then((data) => {
          dispatch(setDashboardData({...data.dasbhoardPage}));
          dispatch(setproductsData({ ...data.productsPage }));
          dispatch(setAccountsData({ ...data.accountsPage }));
          LocalStorage.setLSValue("dashBoardData", { ...data.dasbhoardPage });
          LocalStorage.setLSValue("productsData", { ...data.productsPage });
          LocalStorage.setLSValue("accountsData", { ...data.accountsPage });
        });
    }
  }, [dashBoardData]);
  return (
    <div>
      <Header />
      {!dashBoardData ? (
        <h1 className={styles.dashboardLoading}>Loading....</h1>
      ) : (
        <main id={styles.dashBoardMain}>
          <h1 className={styles.dasbhoardPageHeading}>Welcome back, admin</h1>
          <div className={styles.dashBoardDiv}>
            <LatestHits />
            <Performance />
            <StorageSection />
            <Notifications />
            <OrdersSection />
          </div>
        </main>
      )}
    </div>
  );
};

export default DashBoard;
